var render, staticRenderFns
import script from "./BTab.vue?vue&type=script&lang=ts&"
export * from "./BTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe9b46",
  null
  
)

export default component.exports